import { NavLink } from "react-router";
import MetasList from "../../components/Metas/MetasList";
import { useTrads } from "../../contexts/trads/useTrads";
function AdminMetas(){
  const {translate}=useTrads();
  return (
  <div>
    <nav>
        <NavLink className="btn btn-primary mt-3" to={`/metas/add`}>{translate('btn_add')}</NavLink>
    </nav>
    <MetasList   />
  </div>
  );
}
export default AdminMetas;